import clsx from 'clsx';

import {ImageBlock} from '@/components/image/ImageBlock';
import type {ImageWeb} from '@/components/image/types';

type Props = {
	name?: string;
	imageWeb?: ImageWeb;
	quote?: string;
	role?: string;
	customer?: string;
};

export const TestimonialCard = ({
	name,
	imageWeb,
	quote,
	role,
	customer,
}: Props) => {
	return (
		<div
			className={clsx(
				'flex',
				'flex-col',
				'items-center',
				'text-center',
				'gap-8',
				'max-w-[840px]',
			)}
		>
			{imageWeb && (
				<div className={clsx('w-full', 'max-w-[100px]', 'shrink-0')}>
					<ImageBlock
						src={imageWeb.image.src}
						width={imageWeb.image.width}
						height={imageWeb.image.height}
						alt={imageWeb.altText ?? ''}
						className={clsx(
							'rounded-full',
							'border-[3px]',
							'border-secondary-base-default',
						)}
					/>
				</div>
			)}

			<blockquote
				className={clsx(
					'text-primary-text-default',
					'text-balance',
					'max-md:text-body-short-sm',
				)}
			>
				<span className="text-secondary">&laquo;</span>
				{quote}
				<span className="text-secondary">&raquo;</span>
			</blockquote>

			<div>
				{name && (
					<span className={clsx('block', 'font-bold')}>{name}</span>
				)}
				{role && (
					<span className={clsx('text-primary-text-subtle')}>
						{role}
					</span>
				)}
				{role && customer && (
					<span className={clsx('text-primary-text-subtle')}>
						{' '}
						-{' '}
					</span>
				)}
				{customer && (
					<span className={clsx('text-primary-text-subtle')}>
						{customer}
					</span>
				)}
			</div>
		</div>
	);
};
